import { getCurrentLocale, getCurrentShortLocale } from '@/lib/i18n/core/currentLanguage';

/**
 * エラーレスポンスの displayMessages から現在ロケールのメッセージを取り出す。
 * displayMessages のキーは発生源により短縮コード（`ja`）と BCP 47（`ja-JP`）が
 * 混在するため両方を試し、該当ロケールが無ければ displayMessage にフォールバックする。
 */
export function resolveLocalizedDisplayMessage(data: {
  displayMessages?: Record<string, string>;
  displayMessage?: string;
}): string | undefined {
  return data.displayMessages?.[getCurrentShortLocale()] ?? data.displayMessages?.[getCurrentLocale()] ?? data.displayMessage;
}